import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogActions, DialogContent, DialogContentText, IconButton, InputAdornment, Typography } from '@mui/material';
import { IconClose } from 'assets/icons';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import { SLICE_NAME } from 'constants/common';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { color } from 'theme';
import { setCloseDialogCC } from 'utils/helpers';
import DialogBaseCC from './DialogBaseCC';
import { DIALOG_ID } from './constant';

const DialogConfirmEncryptedToken = () => {
    const propsDialog = useLegacyDialogProps();
    const { t } = useTranslation('pgRecordings')
    const { title, contentText, onClick, error, action = 'dialog.encrypt.confirm'} = propsDialog
    const { isLoading } = useSelector(state => state[SLICE_NAME.COMMON])
    const [showToken, setShowToken] = useState(false)
    const [token, setToken] = useState('');
    const { open } = useSelector((state) => state.dialog);
    const [onClickSubmit, setOnClickSubmit] = useState(false);

    const handleCancel = () => {
        setCloseDialogCC()
    }

    const handleOnClick = () => {
        setOnClickSubmit(true);
        if(token.length === 0){
            return;
        }
        setCloseDialogCC();
        onClick(token);
    }

    useEffect(() => {
        if(open){
            setShowToken(false);
            setToken('')
            setOnClickSubmit(false)
        }
    }, [open])

    return (
        <DialogBaseCC id={DIALOG_ID.CONFIRM_ENCRYPTED_TOKEN} title={t(title)}>
            <DialogContent>
                <DialogContentText>
                    {t(contentText)}
                </DialogContentText>
                <Box sx={{marginTop: '1rem'}}>
                    <Typography>{t('dialog.encrypt.label')} <span style={{color: color.redP01}}>*</span></Typography>
                    <TextFieldVMP
                        error={(onClickSubmit && token.length === 0) || error} 
                        helperText={(onClickSubmit && token.length === 0 && t('dialog.encrypt.helperText')) || error}  
                        autoFocus={true}
                        type={showToken ? 'text' : 'password'}
                        value={token}
                        onChange={(e) => {
                            setToken(e.target.value)
                        }}
                        onKeyDown={(e) => {
                            if(e?.keyCode === 13){
                                e.preventDefault();
                                handleOnClick()
                            }
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {token !== "" ? (
                                        <IconButton
                                            tabIndex={-1}
                                            onClick={() => setToken("")}
                                        >
                                            <IconClose />
                                        </IconButton>
                                    ) : (
                                        <></>
                                    )}
                                    <IconButton
                                        tabIndex={-1}
                                        onClick={() => setShowToken(!showToken)}
                                    >
                                        {showToken ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleCancel}>{t('dialog.encrypt.cancel')}</Button>
                <LoadingButton disabled={(onClickSubmit && token.length === 0)} variant='contained' loading={isLoading} onClick={handleOnClick}>{t(action)}</LoadingButton>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogConfirmEncryptedToken